export default __webpack_public_path__ + "static/media/01_photo.49fae3a6.jpg";